import { forwardRef } from "react";
import { TextBoxWithFlag, Flag, Text } from "./TextBoxWithFlag.tsx";
import { ES } from "country-flag-icons/react/3x2";
import { UserVideoWord } from "@shared_types";
import HighlightedWords, { HighlightedWordsRef } from "./HighlightedWords.tsx";

interface SubtitleProps {
  userVideoWords: UserVideoWord[];
  className?: string;
  highlightIndex: number;
  onWordClick: (clickedWord: UserVideoWord) => void;
  onDoubleWordClick?: (clickedWord: UserVideoWord) => void;
  reviewWord?: UserVideoWord;
  onPhraseSelectedDone: (
    startWord: UserVideoWord,
    endWord: UserVideoWord
  ) => void;
  onPhraseSelectStart: () => void;
}

const Subtitle = forwardRef<HighlightedWordsRef, SubtitleProps>(
  (
    {
      userVideoWords,
      className,
      highlightIndex,
      onWordClick,
      onDoubleWordClick,
      reviewWord,
      onPhraseSelectedDone,
      onPhraseSelectStart,
    },
    ref
  ) => {
    return (
      <>
        <TextBoxWithFlag className={className}>
          <Flag>
            <ES title="Spain" className="w-8" />
          </Flag>
          <Text>
            <HighlightedWords
              ref={ref}
              words={userVideoWords}
              highlightPosition={highlightIndex}
              onWordClick={onWordClick}
              onDoubleWordClick={onDoubleWordClick || (() => {})}
              reviewWord={reviewWord}
              onPhraseSelectStart={onPhraseSelectStart}
              onPhraseSelectedDone={onPhraseSelectedDone}
            />
          </Text>
        </TextBoxWithFlag>
      </>
    );
  }
);

export default Subtitle;
